export default __webpack_public_path__ + "static/alkanza-be436d474b1e232f8bbb7a222e695f13.svg";